import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ICompany } from '@bca-shared/models/company';

@Component({
  selector: 'bca-company-info',
  templateUrl: 'company-info.component.html',
  styleUrls: ['company-info.component.scss']
})
export class CompanyInfoComponent {
  @Input()
  company: ICompany;
  @Output()
  edit = new EventEmitter<void>();
}
